<template>
    <div class="system-dialog">
        <el-dialog :title="system.name"
                   :visible.sync="showDialog"
                   class="system-details-dialog"
                   :before-close="onClose"
                   center>
            <el-row type="flex" justify="center" style="position: relative">
                <el-image :src="system.imgDetails"
                        :class="'system-image-details'"
                          @load="onImgLoad"
                ></el-image>
                <background style="width: 100%; height: 100%; position: absolute; max-width: 600px; pointer-events:none;"
                            v-show="imageLoaded"
                            :desktop="'system-details'"
                            :tablet="'system-details'"
                            :mobile="'system-details'"
                ></background>
            </el-row>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain class="retro action-button" @click="onClose">Back</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import Background from '@/components/background.vue'

export default {
  name: 'SystemDialog',
  components: { Background },
  props: [ 'system', 'onClose' ],
  mounted () {},
  data () {
    return {
      imageLoaded: false,
      showDialog: true
    }
  },

  methods: {
    onImgLoad () {
      this.imageLoaded = true
    }
  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.system-dialog {
    .el-dialog{
        width: 60%;
        background-color: $main-color-1;
        color: $main-color-2;
        border-radius: 25px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.10);

        .el-dialog__title {
            color: $main-color-2;
        }
    }

    .system-image-details {
        z-index: 2;
        max-width: 600px;
    }

    @media screen and (max-width: 61em) {
        .el-dialog {
            width: 80%;
        }
    }

    @media screen and (max-width: 35em) {
        .el-dialog {
            width: 90%;
        }
    }
}
</style>
